// src/utils/editor/searchForSimilarJokes.js

// input: a single joke string
// action: compare against hashTable, then return match or original string 
// output: a joke object or the original string
import stringSimilarity from 'string-similarity';

export const searchForSimilarJokes = (inputString, audienceResponseHashTable) => {
  // console.log("STARTING SEARCH: ", inputString, audienceResponseHashTable); // RETURNING VALID STRING AND OBJECT
  let bestMatch = { score: 0, joke: null };
  
  if (typeof inputString !== 'string') {
    // console.error("Input string is not valid:", inputString); // NOT TRIGGERING, WHICH IS GOOD
    return inputString;  // Return the original value if it's not a string
  }

  // Iterate over the jokes in the hash table and calculate similarity
  for (const jokeKey in audienceResponseHashTable) {
    const jokeObject = audienceResponseHashTable[jokeKey];
    
    if (typeof jokeObject.originalText !== 'string') {
      // console.error("Original text is not a string for joke key:", jokeKey);
      continue;  // Skip if originalText is not a string
    }
    
    const similarity = stringSimilarity.compareTwoStrings(inputString, jokeObject.originalText);

    if (similarity >= 0.8 && similarity > bestMatch.score) {
      bestMatch = { score: similarity, joke: jokeObject };
    }
  }

  // Check if bestMatch.joke exists and has the required properties
  if (bestMatch.score >= 0.8 && bestMatch.joke) {
    const punchline = bestMatch.joke.punchline || {};  // Default to empty object if undefined
    const setup = bestMatch.joke.setup || [];  // Default to empty array if undefined
    const taglines = bestMatch.joke.taglines || [];  // Default to empty array if undefined

    // If a match is found, keep the input string and add punchline.response and taglines.punchline.response
    const updatedJoke = {
      originalText: inputString,  // Keep the original (new) text
      punchline: {
        ...punchline,  // Copy the existing punchline object
        response: punchline.response || ''  // Attach the response from the hash table, default to empty
      },
      setup: setup.map(line => line),  // Ensure setup is an array
      taglines: taglines.map(tagline => ({
        punchline: {
          ...tagline.punchline,  // Copy the existing tagline punchline
          response: tagline.punchline?.response || ''  // Attach tagline punchline response, default to empty
        }
      }))
    };
    // console.log("MATCH FOUND FOR:", inputString, updatedJoke);  // THIS IS CORRECTLY SHOWING THAT AUDIENCE RESPONSES WERE ADDED, BUT IT'S STILL NOT IN THE EDITOR.
    return updatedJoke;
  }

  // If no match is found, return the original string
  //console.log("NO MATCH FOUND FOR:", inputString);
  return inputString; 
};
